import React, { useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Switch } from "@/components/ui/switch";
import { useToast } from "@/hooks/use-toast";
import { Users, DollarSign, CheckCircle } from "lucide-react";
import { getCurrentClientData } from "@/services/authServices";
import { EventInput, EventsService } from "@/api/events";
import ImageUploader from "@/components/ImageUploader";
import { uploadMediaApi } from "@/services/eventsServiices";
import { useSearchParams } from "react-router-dom";
import TicketTypeManager, {
  TicketType,
} from "@/components/event-ticket/TicketTypeManager";
import UpgradePrompt from "@/components/subscription/UpgradePrompt";
import UpgradeModal from "@/components/subscription/UpgradeModal";
import { useNavigate } from "react-router-dom";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import TicketIcon from "@/assets/img/money-remove.png";
import BankIcon from "@/assets/img/bank-icon.png";

// import { updatePayoutAccount } from "@/services/payoutServices";

export interface EventDataResponse {
  title: string;
  description: string;
  category: string;
  date: string;
  startTime: string;
  endTime: string;
  location: string;
  isVirtual: string;
  ticket_price: string;
  max_attendees: string;
  ticket_type: string;
  image: any;
  agenda: any[];
  speakers: any[];
  meetingLink: string;
  event_id: string;
  timeZone?: string; // Optional field for timezone
  is_free?: boolean;
}
const CreateEvent = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const loggedInUser = getCurrentClientData();
  const {
    postEvents,
    getEvents1,
    putEvents,
    createMeeting,
    createPayoutAccount,
    getPayoutAccount,
  } = EventsService;
  const [currentStep, setCurrentStep] = useState(1);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("edit");
  const [showMeetingLink, setShowMeetingLink] = useState(false);
  // const { isPro, navigateToUpgrade } = useSubscription();
  const [isPro, setIsPro] = useState(false);
  const [payoutResponse, setPayoutResponse] = useState<any | null>(null);

  const [isValid, setIsValid] = useState(false);
  const [timeError, setTimeError] = useState(""); // New state for time error
  const [maxAttendeesError, setMaxAttendeesError] = useState(""); // New state for max attendees error
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(!!eventId);
  const [ticketTypes, setTicketTypes] = useState<TicketType[]>([]);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [upgradeFeatureName, setUpgradeFeatureName] = useState("");
  const [originalImageUrl, setOriginalImageUrl] = useState<string | null>(null); // New state to store original image URL
  const [payoutLoading, setPayoutLoading] = useState(false);
  const payoutStatus = loggedInUser?.payout;
  const [isReturningFromPayoutSetup, setIsReturningFromPayoutSetup] =
    useState(false);

  const [eventDataResponse, setEventDataResponse] = useState({
    title: "",
    description: "",
    category: "",
    date: "",
    startTime: "",
    endTime: "",
    location: "",
    isVirtual: "No",
    ticket_type: "",
    // ticket: [
    //   {
    //     ticket_price: "",
    //     max_attendees: "",
    //   },
    // ],
    ticket_price: "",
    max_attendees: "",
    image: null,
    agenda: [],
    speakers: [],
    meetingLink: "",
    event_id: "",
    event_title: "",
    is_free: true,
  });
  const [eventData, setEventData] = useState<EventDataResponse>({
    title: "",
    description: "",
    category: "",
    date: "",
    startTime: "",
    endTime: "",
    location: "",
    isVirtual: "No",
    ticket_price: "",
    max_attendees: "",
    ticket_type: "",
    image: null,
    agenda: [],
    speakers: [],
    meetingLink: "",
    event_id: "",
    timeZone: "",
    is_free: true,
  });

  const saveDrafteToStorage = () => {
    try {
      const draft = {
        ...eventData,
        event_title: eventData.title,
        event_description: eventData.description,
        category: eventData.category,
        date: eventData.date,
        start_time: eventData.startTime,
        end_time: eventData.endTime,
        virtual_event: eventData.isVirtual,
        location: eventData.location,
        ticket_price: eventData.ticket_price,
        max_attendees: eventData.max_attendees,
        ticket_type: eventData.ticket_type,
        image: eventData.image,
        agenda: eventData.agenda,
        speakers: eventData.speakers,
        meetingLink: eventData.meetingLink,
        event_id: eventData.event_id,
        timeZone: eventData.timeZone,
        is_free: eventData.is_free,
      };
      localStorage.setItem("create_event_draft", JSON.stringify(draft));
      console.log("Draft saved to localStorage:", draft);
      sessionStorage.setItem(
        "create_event_draft_session",
        JSON.stringify(draft)
      );
    } catch (error) {
      console.log("Error saving draft:", error);
    }
  };

  const getUserTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };

  useEffect(() => {
    // Perform time validation whenever startTime or endTime changes
    if (eventData.startTime && eventData.endTime) {
      const startTimeDate = new Date(`2000-01-01T${eventData.startTime}`);
      const endTimeDate = new Date(`2000-01-01T${eventData.endTime}`);

      if (endTimeDate <= startTimeDate) {
        setTimeError("End time must be later than start time.");
      } else {
        setTimeError("");
      }
    } else {
      setTimeError(""); // Clear error if either time is empty
    }
  }, [eventData.startTime, eventData.endTime]);

  // useEffect(() => {
  //   console.log("eventData.isVirtual", eventData, isValid);
  //   if (eventData.isVirtual && !isValid && eventData.meetingLink === "") {
  //     handleCreateMeeting();
  //   } else {
  //     setShowMeetingLink(false);
  //     setIsValid(false);
  //   }
  // }, [eventData.isVirtual]);
  useEffect(() => {
    const stripeReturn = searchParams.get("stripe_return");
    const payoutSetup = searchParams.get("payout_setup");

    if (stripeReturn === "true" && payoutSetup === "complete") {
      setIsReturningFromPayoutSetup(true);
      // 1. Show Success Notification
      toast({
        title: "Payout Setup Complete! 🎉",
        description:
          "Your payout account is successfully connected. You can now sell paid tickets.",
        variant: "default",
      });

      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete("stripe_return");
      newSearchParams.delete("payout_setup");
    }
  }, [searchParams, toast, navigate, eventId]);
  const loadEventData = async (id: string) => {
    const userTimezone = getUserTimezone();

    try {
      const res: any = await getEvents1(id, loggedInUser?.token);

      if (res.statusCode === 200 || res.statusCode === 201) {
        const eventDetails = res.body.data;

        setEventData({
          title: eventDetails.event_title,
          description: eventDetails.event_description,
          category: eventDetails.category,
          date: eventDetails.event_date,
          startTime: eventDetails.start_time,
          endTime: eventDetails.end_time,
          isVirtual: eventDetails.virtual_event,

          ticket_price: eventDetails.ticket_price,
          max_attendees: eventDetails.max_attendees,
          timeZone: userTimezone,
          is_free: eventDetails.is_free,

          // timeZone: eventDetails.timeZone,
          image: eventDetails.img_url?.[0],
          agenda: [], // Adjust based on your data structure
          speakers: [], // Adjust based on your data structure
          event_id: eventDetails.event_id,

          ticket_type: eventDetails.ticket_type,
          ...(eventDetails.virtual_event === "Yes" &&
            eventDetails.meeting_link && {
              meetingLink: eventDetails.meeting_link,
            }),
          ...(eventDetails.virtual_event === "No" &&
            eventDetails.location && {
              location: eventDetails.location,
            }),
        });
        setTicketTypes(eventDetails.ticketTypes);
        setOriginalImageUrl(eventDetails.img_url?.[0] || null);
      } else {
        toast({
          title: "Error loading event",
          description: res.body.message || "Failed to load event details.",
          variant: "destructive",
        });
      }
    } catch (error) {
      toast({
        title: "Error loading event",
        description: "There was an error fetching event details.",
        variant: "destructive",
      });
    }
  };

  useEffect(() => {
    if (eventData.isVirtual === "Yes") {
      setEventData((prev) => ({ ...prev, location: "" }));
      if (!eventData.meetingLink) {
        handleCreateMeeting();
      }
    } else {
      setEventData((prev) => ({ ...prev, meetingLink: "" }));
      setShowMeetingLink(false); // Ensure meeting link input is hidden
      setIsValid(false); // Reset isValid state if needed
    }
  }, [eventData.isVirtual]); // Depend only on isVirtual for this logic

  const clearDraftFromStorage = () => {
    try {
      localStorage.removeItem("create_event_draft");
      console.log("Draft cleared from localStorage.");
      sessionStorage.removeItem("create_event_draft_session");
    } catch (error) {
      console.log("Error clearing draft from localStorage:", error);
    }
  };
  useEffect(() => {
    const isEditing = !!searchParams.get("edit");

    if (isEditing) {
      setIsEditMode(true);
      loadEventData(eventId);
    } else {
      setIsEditMode(false);
      const storedDraft =
        localStorage.getItem("create_event_draft") ||
        sessionStorage.getItem("create_event_draft_session");
      if (storedDraft) {
        try {
          const parsedDraft = JSON.parse(storedDraft);
          setCurrentStep(2);
          setEventData(parsedDraft);
          console.log("Draft restored on mount:", parsedDraft);
          return; // Avoid overwriting with defaults in this effect run
        } catch (e) {
          console.warn("Failed to parse saved draft, using defaults.", e);
        }
      }
      setEventData({
        title: "",
        description: "",
        category: "",
        date: "",
        startTime: "",
        endTime: "",
        location: "",
        isVirtual: "No",
        ticket_price: "",
        max_attendees: "",
        is_free: true,
        ticket_type: "",
        image: null,
        agenda: [],
        speakers: [],
        meetingLink: "",
        event_id: "",
        timeZone: "",
      });
    }
  }, [searchParams, eventId]);

  useEffect(() => {
    const loadPayoutStatus = async () => {
      try {
        if (!loggedInUser?.token) return;
        const status: any = await getPayoutAccount(loggedInUser.token);
        console.log("ztatus", status.payout);
        // Service returns either raw object or wrapped; be defensive
        // const normalized =
        //   (status &&
        //     (status.data?.data ||
        //       status.data ||
        //       status.body?.data ||
        //       status)) ||
        //   null;
        // console.log("Payout status loaded:", normalized);
        setPayoutResponse(status?.payout);
        setIsReturningFromPayoutSetup(true);

        // setPayoutStatus(normalized);
      } catch (err) {
        console.error(err);
        setIsReturningFromPayoutSetup(false);

        setPayoutResponse(null);
      }
    };
    loadPayoutStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleCreatePayoutAccount = async () => {
    if (!loggedInUser?.token) return;
    saveDrafteToStorage();

    setPayoutLoading(true);
    try {
      const res: any = await createPayoutAccount(loggedInUser.token);
      const payload = res;
      const url = payload?.onboardingUrl;

      // payload?.accountId ||
      // payload?.message
      // payload?.dashboardUrl ||
      // payload?.updateUrl ||
      // payload?.url ||
      // payload?.link ||
      // payload?.accountLink;

      // if (url) {
      //   window.open(url, "_blank", "noopener");
      // }
      toast({
        title: "Payout account",
        description: payload?.message || "Request processed.",
      });

      if (url) {
        window.location.href = url; // replaces current page
      }
      const response: any = await getPayoutAccount(loggedInUser.token);

      setPayoutResponse(response?.payout);
      setIsReturningFromPayoutSetup(true);
    } catch (error) {
      toast({
        title: "Payout error",
        description: "Unable to create payout account.",
        variant: "destructive",
      });
      setIsReturningFromPayoutSetup(false);

      setPayoutLoading(false);
    } finally {
      setIsReturningFromPayoutSetup(false);

      setPayoutLoading(false);
    }
  };

  // const handleUpdatePayoutAccount = async () => {
  //   if (!loggedInUser?.token) return;
  //   setPayoutLoading(true);
  //   try {
  //     const res: any = await updatePayoutAccount(loggedInUser.token, {});
  //     const payload = res?.body?.data || res?.data || res;
  //     const url =
  //       payload?.updateUrl ||
  //       payload?.dashboardUrl ||
  //       payload?.onboardingUrl ||
  //       payload?.url ||
  //       payload?.link ||
  //       payload?.accountLink;
  //     if (url) {
  //       window.open(url, "_blank", "noopener");
  //     }
  //     toast({
  //       title: "Payout account",
  //       description: payload?.message || "Update link opened in a new tab.",
  //     });
  //   } catch (error) {
  //     toast({
  //       title: "Payout error",
  //       description: "Unable to update payout account.",
  //       variant: "destructive",
  //     });
  //   } finally {
  //     setPayoutLoading(false);
  //   }
  // };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setEventData({ ...eventData, [name]: value });
    if (name === "max_attendees") {
      const numericValue = parseInt(value, 10); // Convert string value to a number
      setMaxAttendeesError("");
      if (isNaN(numericValue)) return;

      // Show error if negative
      if (numericValue < 0) {
        setMaxAttendeesError("Number of attendees cannot be negative.");
      }

      if (
        numericValue > 100 &&
        loggedInUser.account_type?.account_type === "standard"
      ) {
        setMaxAttendeesError(
          "Limit is reached to add more participants. Go Pro!"
        );
      }
    }
  };

  const handleCreateMeeting = async () => {
    const userTimezone = getUserTimezone();

    // Check description
    if (eventData.description === "") {
      toast({
        title: "Error",
        description: "Please enter a event description.",
        variant: "destructive",
      });
      // Focus on the description field
      document.getElementById("description")?.focus();
      setIsValid(true);
      setEventData({ ...eventData, isVirtual: "No" });

      return; // Stop execution
    }

    // Check title
    if (eventData.title === "") {
      toast({
        title: "Error",
        description: "Please enter a event title.",
        variant: "destructive",
      });
      document.getElementById("title")?.focus();
      setIsValid(true);
      setEventData({ ...eventData, isVirtual: "No" });

      return;
    }

    // Check start time
    if (eventData.startTime === "") {
      toast({
        title: "Error",
        description: "Please select a start time.",
        variant: "destructive",
      });
      document.getElementById("startTime")?.focus();
      setIsValid(true);
      setEventData({ ...eventData, isVirtual: "No" });

      return;
    }

    // Check end time
    if (eventData.endTime === "") {
      toast({
        title: "Error",
        description: "Please select an end time.",
        variant: "destructive",
      });
      document.getElementById("endTime")?.focus();
      setIsValid(true);
      setEventData({ ...eventData, isVirtual: "No" });

      return;
    }

    // Check date
    if (eventData.date === "") {
      toast({
        title: "Error",
        description: "Please select a event date.",
        variant: "destructive",
      });
      document.getElementById("date")?.focus();
      setIsValid(true);
      setEventData({ ...eventData, isVirtual: "No" });

      return;
    }

    if (
      !eventData.is_free &&
      (eventData.ticket_price === "" || Number(eventData.ticket_price) < 1)
    ) {
      toast({
        title: "Error",
        description: "Please enter a valid ticket price (minimum $1).",
        variant: "destructive",
      });
      document.getElementById("ticket_price")?.focus();
      setIsValid(true);
      return;
    }

    setIsValid(false);

    setShowMeetingLink(true);
    // setEventData((prev) => ({ ...prev, isVirtual: false })); // ✅ Only set isVirtual to false if no validation error

    try {
      const payload = {
        event_name: eventData.title,
        email: loggedInUser?.clientData?.email,
        start_time: eventData.startTime,
        end_time: eventData.endTime,
        event_date: eventData.date,
        timezone: userTimezone,
        // timezone: eventData.timeZone,
        attendees: [loggedInUser?.clientData?.email],
        description: eventData.description,
      };

      const res: any = await createMeeting(payload);
      if (res.statusCode === 200) {
        setIsValid(false);

        setShowMeetingLink(false);
        setEventData({ ...eventData, meetingLink: res.body.data.meeting_link });
      } else {
        console.error("Error creating meeting:", res);
        toast({
          title: "Error",
          description:
            res.body.message || "There was an error creating your meeting.",
          variant: "destructive",
        });
        setLoading(false);
        setEventData({
          ...eventData,
          isVirtual: "No",
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "There was an error creating your meeting.",
        variant: "destructive",
      });
      setLoading(false);
      return;
    }
  };

  const handleCreateEvent = async () => {
    setLoading(true);

    const data = {
      file_data: eventData.image,
      isBase64Encoded: true,
    };

    try {
      const res: any = await uploadMediaApi(loggedInUser.token, data);

      if (res.data.statusCode === 200) {
        const fullUrl = res.data.body.results[0].img_url;
        const cleanedPath = fullUrl.replace(
          /^.*user-uploads\//,
          "user-uploads/"
        );
        createEventFn(cleanedPath);
      } else {
        toast({
          title: "Error",
          description:
            res.body.message || "There was an error uploading your image.",
          variant: "destructive",
        });
        setLoading(false);
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "There was an error uploading your image.",
        variant: "destructive",
      });
      setLoading(false);
      return;
    }
  };

  const handleUpdateEvent = async () => {
    const isNewImageSelected =
      eventData.image && eventData.image !== originalImageUrl;
    const uploadedImageUrl = originalImageUrl; // Start with the original image URL

    if (isNewImageSelected) {
      const data = {
        file_data: eventData.image,
        isBase64Encoded: true,
      };
      try {
        const res: any = await uploadMediaApi(loggedInUser.token, data);
        if (res.data.statusCode === 200) {
          const fullUrl = res.data.body.results[0].img_url;
          const cleanedPath = fullUrl.replace(
            /^.*user-uploads\//,
            "user-uploads/"
          );

          updateDataApi(cleanedPath);
        } else {
          toast({
            title: "Error",
            description:
              res.body.message || "There was an error uploading your image.",
            variant: "destructive",
          });
          return;
        }
      } catch (error) {
        toast({
          title: "Error",
          description: "There was an error uploading your image.",
          variant: "destructive",
        });
        return;
      }
    } else {
      const updatedUrl = uploadedImageUrl.split("?")[0];
      const finalImgUrl = updatedUrl.split("/user-uploads/")[1];
      updateDataApi(`user-uploads/${finalImgUrl}`);
    }
  };

  const updateDataApi = async (img_url: string) => {
    const userTimezone = getUserTimezone();

    const accountType = loggedInUser?.account_type?.account_type;

    const payload: EventInput = {
      is_free: eventData.is_free,

      event_id: eventData.event_id,
      event_title: eventData.title,
      event_description: eventData.description,
      event_date: eventData.date,
      start_time: eventData.startTime,
      end_time: eventData.endTime,
      virtual_event: eventData.isVirtual,
      timezone: userTimezone,
      // timezone: eventData.timeZone,

      ...(eventData.isVirtual === "Yes" &&
        eventData.meetingLink && {
          meeting_link: `https://${eventData.meetingLink.replace(
            /^https?:\/\//,
            ""
          )}`,
        }),
      ...(eventData.isVirtual === "No" &&
        eventData.location && {
          location: eventData.location,
        }),
      ...(Array.isArray(ticketTypes) &&
        ticketTypes.length > 0 && {
          ticketTypes: ticketTypes,
        }),

      ...(eventData.is_free === false && {
        ticket_price: eventData.ticket_price,
      }),

      // ticket_price: eventData.ticket_price,
      max_attendees: eventData.max_attendees,
      account_type: accountType,
      category: eventData.category,
      img_url: [img_url], // from upload
    };

    try {
      const res: any = await putEvents(loggedInUser.token, eventId, payload);
      if (res.statusCode === 200 || res.statusCode === 201) {
        setEventDataResponse(res?.body?.data);

        toast({
          title: "Event Updated!",
          description:
            res.body.message || "Your event has been updated successfully.",
          variant: "default",
        });
        setFormSubmitted(true);
      } else {
        toast({
          title: "Error",
          description:
            res.body.message || "There was an error updating your event.",
          variant: "destructive",
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "There was an error updating your event.",
        variant: "destructive",
      });
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (
      !eventData.title ||
      !eventData.description ||
      !eventData.date ||
      !eventData.image
      // !eventData.ticket_price
    ) {
      toast({
        title: "Missing Information",
        description: "Please fill out all required fields.",
        variant: "destructive",
      });
      return;
    }

    if (timeError) {
      toast({
        title: "Invalid Time",
        description: timeError,
        variant: "destructive",
      });
      return;
    }
    if (maxAttendeesError) {
      toast({
        title: "Invalid Attendees",
        description: maxAttendeesError,
        variant: "destructive",
      });
      return;
    }

    if (isEditMode && eventId) {
      handleUpdateEvent();
    } else {
      handleCreateEvent();
    }
  };

  const createEventFn = async (img_url: string) => {
    const userTimezone = getUserTimezone();

    setLoading(true);
    const accountType = loggedInUser?.account_type?.account_type;

    let data: EventInput;

    if (accountType === "standard") {
      data = {
        // ...eventData,
        is_free: eventData.is_free,
        event_title: eventData.title,
        event_description: eventData.description,
        category: eventData.category,
        event_date: eventData.date,
        start_time: eventData.startTime,
        end_time: eventData.endTime,
        virtual_event: eventData.isVirtual,
        img_url: [img_url],
        timezone: userTimezone,
        // timezone: eventData.timeZone,

        ...(eventData.is_free === false && {
          ticket_price: eventData.ticket_price,
        }),

        max_attendees: eventData.max_attendees,

        ...(eventData.isVirtual === "Yes" &&
          eventData.meetingLink && {
            meeting_link: `https://${eventData.meetingLink.replace(
              /^https?:\/\//,
              ""
            )}`,
          }),

        ...(eventData.isVirtual === "No" &&
          eventData.location && {
            location: eventData.location,
          }),
      };
    } else {
      data = {
        // ...eventData,
        is_free: eventData.is_free,

        event_title: eventData.title,
        event_description: eventData.description,
        category: eventData.category,
        timezone: userTimezone,
        // timezone: eventData.timeZone,

        event_date: eventData.date,
        start_time: eventData.startTime,
        end_time: eventData.endTime,
        virtual_event: eventData.isVirtual,
        ...(eventData.is_free === false && {
          ticket_price: eventData.ticket_price,
        }),

        // ticket_price: eventData.ticket_price,
        max_attendees: eventData.max_attendees,

        img_url: [img_url],
        ...(Array.isArray(ticketTypes) &&
          ticketTypes.length > 0 && {
            ticketTypes: ticketTypes,
          }),
        account_type: "pro",
        ...(ticketTypes.length > 0 && { tickets: ticketTypes }), // ✅ Only add if not empty
        ...(eventData.isVirtual === "Yes" &&
          eventData.meetingLink && {
            meeting_link: `https://${eventData.meetingLink.replace(
              /^https?:\/\//,
              ""
            )}`,
          }),

        ...(eventData.isVirtual === "No" &&
          eventData.location && {
            location: eventData.location,
          }),
      };
    }
    try {
      const res: any = await postEvents(data, loggedInUser?.token);
      if (res.statusCode === 200 || res.statusCode === 201) {
        setEventDataResponse(res?.body?.data);
        clearDraftFromStorage();

        toast({
          title: "Event Created!",
          description:
            res.body.message || "Your event has been created successfully.",
          variant: "default",
        });
        setLoading(false);
        setFormSubmitted(true);
        navigate("/dashboard");
      } else {
        toast({
          title: "Error",
          description:
            res.body.message || "There was an error creating your event.",
          variant: "destructive",
        });
        setLoading(false);
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "There was an error creating your event.",
        variant: "destructive",
      });
      setLoading(false);
      return;
    } finally {
      setLoading(false);
    }
  };

  const nextStep = () => {
    if (eventData.isVirtual === "Yes") {
      if (eventData.meetingLink === "") {
        toast({
          title: "Error",
          description: "Please create a meeting link.",
          variant: "destructive",
        });
        return;
      } else {
        if (currentStep < 3) {
          setCurrentStep(currentStep + 1);
          if (currentStep === 2) {
            clearDraftFromStorage();
          }
        }
      }
    } else {
      if (currentStep < 3) {
        setCurrentStep(currentStep + 1);
        if (currentStep === 2) {
          clearDraftFromStorage();
        }
      }
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleShowUpgradeModal = (featureName?: string) => {
    setUpgradeFeatureName(featureName);
    setShowUpgradeModal(true);
  };

  const handleUpgrade = () => {
    // setUpgrading(true);
    // setIsPro(true);
    navigate("/billing");
    setShowUpgradeModal(false);
    // await upgradeSubscription();
    // setUpgrading(false);
    // onClose();
  };

  // const handleCreatePayoutAccount = () => {
  //   setShowCreatePayoutAccount(!showCreatePayoutAccount);
  // };

  if (formSubmitted && eventDataResponse) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow flex items-center justify-center bg-gray-50">
          <Card className="w-full max-w-3xl">
            <CardContent className="pt-6 text-center">
              <CheckCircle className="mx-auto h-16 w-16 text-green-500 mb-4" />
              <h1 className="text-2xl font-bold text-cecure-900 mb-2">
                Event Created Successfully!
              </h1>
              <p className="text-gray-600 mb-6">
                Your event "{eventDataResponse.event_title}" has been created
                and is now ready for attendees to register.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Button
                  variant="outline"
                  onClick={() => (window.location.href = "/events")}
                >
                  View Events
                </Button>
                <Button
                  // onClick={() =>
                  //   (window.location.href = `/dashboard/${eventData?.event_id}`)
                  // }
                  // >
                  onClick={() =>
                    navigate(`/dashboard/${eventDataResponse.event_id}`)
                  }
                >
                  Manage Your Events
                </Button>
              </div>
            </CardContent>
          </Card>
        </main>
        <Footer />
      </div>
    );
  }

  console.log("eventData", eventData);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-gray-50">
        {/* Page Header */}
        <div className="bg-cecure-900 text-white py-12">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-bold">
              {isEditMode ? "Edit Event" : "Create a New Event"}
            </h1>
            <p className="mt-2">
              {isEditMode
                ? "Modify your event details, registration, and more"
                : "Set up your event details, registration, and more"}{" "}
            </p>
          </div>
        </div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Progress steps */}
          <div className="mb-8">
            <div className="flex items-center justify-between">
              <div
                className={`flex flex-col items-center ${
                  currentStep >= 1 ? "text-cecure-700" : "text-gray-400"
                }`}
              >
                <div
                  className={`flex items-center justify-center h-8 w-8 rounded-full ${
                    currentStep >= 1
                      ? "bg-cecure-700 text-white"
                      : "bg-gray-200 text-gray-600"
                  }`}
                >
                  1
                </div>
                <span className="text-sm mt-1">Basic Info</span>
              </div>
              <div
                className={`h-1 flex-1 mx-4 ${
                  currentStep >= 2 ? "bg-cecure-700" : "bg-gray-200"
                }`}
              ></div>

              <div
                className={`flex flex-col items-center ${
                  currentStep >= 2 ? "text-cecure-700" : "text-gray-400"
                }`}
              >
                <div
                  className={`flex items-center justify-center h-8 w-8 rounded-full ${
                    currentStep >= 2
                      ? "bg-cecure-700 text-white"
                      : "bg-gray-200 text-gray-600"
                  }`}
                >
                  2
                </div>
                <span className="text-sm mt-1">Registration</span>
              </div>
              <div
                className={`h-1 flex-1 mx-4 ${
                  currentStep >= 3 ? "bg-cecure-700" : "bg-gray-200"
                }`}
              ></div>

              <div
                className={`flex flex-col items-center ${
                  currentStep >= 3 ? "text-cecure-700" : "text-gray-400"
                }`}
              >
                <div
                  className={`flex items-center justify-center h-8 w-8 rounded-full ${
                    currentStep >= 3
                      ? "bg-cecure-700 text-white"
                      : "bg-gray-200 text-gray-600"
                  }`}
                >
                  3
                </div>
                <span className="text-sm mt-1">Review</span>
              </div>
            </div>
          </div>

          <form onSubmit={(e: React.FormEvent) => handleSubmit(e)}>
            {/* ==Step 1: Basic Information== */}
            {currentStep === 1 && (
              <Card>
                <CardContent className="pt-6">
                  <h2 className="text-xl font-semibold mb-4">Event Details</h2>

                  <div className="space-y-6">
                    <div>
                      <Label htmlFor="title">Event Title *</Label>
                      <Input
                        id="title"
                        name="title"
                        value={eventData.title}
                        onChange={handleInputChange}
                        placeholder="e.g., Tech Innovation Summit 2023"
                        className="mt-1"
                        required
                        maxLength={30}
                      />
                    </div>

                    <div>
                      <Label htmlFor="description">Event Description *</Label>
                      <Textarea
                        id="description"
                        name="description"
                        value={eventData.description}
                        onChange={handleInputChange}
                        placeholder="Describe your event..."
                        className="mt-1 resize-none"
                        rows={5}
                        required
                        maxLength={150}
                      />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <Label htmlFor="category">Category *</Label>
                        <Select
                          value={eventData.category}
                          onValueChange={(value) =>
                            setEventData({ ...eventData, category: value })
                          }
                        >
                          <SelectTrigger id="category" className="mt-1">
                            <SelectValue placeholder="Select a category" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="Telecommunications">
                              Technology
                            </SelectItem>
                            <SelectItem value="Marketing">Marketing</SelectItem>
                            <SelectItem value="Healthcare">
                              Healthcare
                            </SelectItem>
                            {/* <SelectItem value="Business">Business</SelectItem> */}
                            <SelectItem value="Education">Education</SelectItem>
                            <SelectItem value="Finance">Finance</SelectItem>
                            <SelectItem value="Government">
                              Government
                            </SelectItem>
                            <SelectItem value="Science">Science</SelectItem>
                            <SelectItem value="Manufacturing">
                              Manufacturing
                            </SelectItem>
                            <SelectItem value="Arts and Culture">
                              Arts and Culture
                            </SelectItem>

                            <SelectItem value="Non-Profit">
                              Non-Profit
                            </SelectItem>
                            <SelectItem value="Energy">Energy</SelectItem>
                            <SelectItem value="Hospitality">
                              Hospitality
                            </SelectItem>
                            <SelectItem value="Retail">Retail</SelectItem>
                            <SelectItem value="Real Estate">
                              Real Estate
                            </SelectItem>
                            <SelectItem value="Legal">Legal</SelectItem>
                            <SelectItem value="Agriculture">
                              Agriculture
                            </SelectItem>
                            <SelectItem value="Transportation">
                              Transportation
                            </SelectItem>
                            <SelectItem value="Media and Entertainment">
                              Media and Entertainment
                            </SelectItem>

                            <SelectItem value="Biotechnology">
                              Biotechnology
                            </SelectItem>
                            <SelectItem value="Telecommunications">
                              Telecommunications{" "}
                            </SelectItem>
                          </SelectContent>
                        </Select>
                      </div>

                      <div>
                        <Label htmlFor="date">Event Date *</Label>
                        <Input
                          id="date"
                          name="date"
                          type="date"
                          value={eventData.date}
                          onChange={handleInputChange}
                          className="mt-1"
                          required
                          min={new Date().toISOString().split("T")[0]}
                        />
                      </div>
                    </div>

                    {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6"> */}
                    <div className="flex items-center gap-6 justify-center">
                      <div className="w-full">
                        <Label htmlFor="startTime">Start Time *</Label>
                        <Input
                          id="startTime"
                          name="startTime"
                          type="time"
                          value={eventData.startTime}
                          onChange={handleInputChange}
                          className="mt-1"
                          required
                        />
                      </div>

                      <div className="w-full">
                        <Label htmlFor="endTime">End Time *</Label>
                        <Input
                          id="endTime"
                          name="endTime"
                          type="time"
                          value={eventData.endTime}
                          onChange={handleInputChange}
                          className="mt-1"
                          required
                        />

                        {timeError && (
                          <p className="text-red-500 text-sm mt-1">
                            {timeError}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* <div>
                        <Label htmlFor="timezone">Timezone *</Label>
                        <Select
                          value={eventData.timeZone}
                          onValueChange={(value) =>
                            setEventData({ ...eventData, timeZone: value })
                          }
                        >
                          <SelectTrigger id="timezone" className="mt-1">
                            <SelectValue placeholder="Select a timezone" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="CET">
                              Central European Time
                            </SelectItem>
                            <SelectItem value="CST6CDT">
                              Central Standard Time / Central Daylight Time (US)
                            </SelectItem>
                            <SelectItem value="EET">
                              Eastern European Time
                            </SelectItem>
                            <SelectItem value="EST">
                              Eastern Standard Time (North America)
                            </SelectItem>
                            <SelectItem value="EST5EDT">
                              Eastern Standard Time / Eastern Daylight Time (US)
                            </SelectItem>
                            <SelectItem value="GB">
                              Great Britain Time (same as Europe/London){" "}
                            </SelectItem>
                            <SelectItem value="GMT">
                              Greenwich Mean Time
                            </SelectItem>
                            <SelectItem value="GMT+0">
                              Greenwich Mean Time
                            </SelectItem>
                            <SelectItem value="GMT-0">
                              Greenwich Mean Time
                            </SelectItem>
                            <SelectItem value="GMT0">
                              Greenwich Mean Time
                            </SelectItem>
                            <SelectItem value="HST">
                              Hawaii Standard Time
                            </SelectItem>
                            <SelectItem value="MET">
                              Middle European Time (alias for CET)
                            </SelectItem>
                            <SelectItem value="MST">
                              Mountain Standard Time (North America)
                            </SelectItem>
                            <SelectItem value="MST7MDT">
                              Mountain Standard Time / Mountain Daylight Time
                            </SelectItem>
                            <SelectItem value="NZ">
                              New Zealand Standard Time
                            </SelectItem>
                            <SelectItem value="NZ-CHAT">
                              Chatham Island Time (New Zealand)
                            </SelectItem>
                            <SelectItem value="PRC">
                              People's Republic of China Standard Time
                            </SelectItem>
                            <SelectItem value="PST8PDT">
                              Pacific Standard Time / Pacific Daylight Time (US)
                            </SelectItem>
                            <SelectItem value="ROC">
                              Republic of China (Taiwan) Standard Time
                            </SelectItem>
                            <SelectItem value="ROK">
                              Republic of Korea (South Korea) Standard Time
                            </SelectItem>
                            <SelectItem value="UCT">
                              Coordinated Universal Time
                            </SelectItem>
                            <SelectItem value="UTC">
                              Coordinated Universal Time
                            </SelectItem>
                            <SelectItem value="W-SU">
                              Russia (Moscow+00) Time
                            </SelectItem>
                            <SelectItem value="WAT">
                              West Africa Time
                            </SelectItem>
                            <SelectItem value="WET">
                              Western European Time
                            </SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div> */}

                    <div>
                      <div className="flex items-center gap-4 mb-2">
                        <Label htmlFor="isVirtual">Virtual Event</Label>
                        <Switch
                          id="isVirtual"
                          checked={eventData.isVirtual === "Yes"}
                          onCheckedChange={(checked) =>
                            setEventData({
                              ...eventData,
                              isVirtual: checked ? "Yes" : "No",
                            })
                          }
                        />
                      </div>

                      <div className="mt-4">
                        <div className="flex items-center justify-between">
                          <Label
                            htmlFor={
                              eventData.isVirtual === "Yes"
                                ? "meetingLink"
                                : "location"
                            }
                          >
                            {eventData.isVirtual === "Yes"
                              ? "Event Link"
                              : "Location *"}
                          </Label>
                        </div>
                        <Input
                          id={
                            eventData.isVirtual === "Yes"
                              ? "meetingLink"
                              : "location"
                          }
                          name={
                            eventData.isVirtual === "Yes"
                              ? "meetingLink"
                              : "location"
                          }
                          value={
                            eventData.isVirtual === "Yes"
                              ? eventData.meetingLink
                              : eventData?.location
                          }
                          onChange={handleInputChange}
                          placeholder={
                            eventData.isVirtual === "Yes"
                              ? "e.g., https://cecurestream.com/events/your-event"
                              : "e.g., Convention Center, San Francisco, CA"
                          }
                          className="mt-1"
                          required
                        />
                      </div>
                    </div>

                    <ImageUploader
                      initialImage={eventData.image}
                      onImageSelect={(image) =>
                        setEventData({ ...eventData, image })
                      }
                    />
                  </div>

                  <div className="mt-8 flex justify-end">
                    <Button
                      type="button"
                      disabled={showMeetingLink}
                      onClick={nextStep}
                    >
                      Next: Registration Details
                    </Button>
                  </div>
                </CardContent>
              </Card>
            )}

            {/* ==Step 2: Registration Details== */}
            {currentStep === 2 && (
              <Card>
                <CardContent className="pt-6">
                  <h2 className="text-xl font-semibold mb-4">
                    Registration Details
                  </h2>

                  <div className="space-y-6">
                    <Tabs defaultValue="tickets">
                      <TabsList className={`grid w-[279px] grid-cols-2 `}>
                        <TabsTrigger
                          className={`aria-selected-]`}
                          value="tickets"
                        >
                          Tickets
                        </TabsTrigger>
                        <TabsTrigger className={`aria-selected-`} value="form">
                          Registration Form
                        </TabsTrigger>
                      </TabsList>

                      <TabsContent value="tickets" className="space-y-6 mt-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div>
                            <Label htmlFor="ticket_type">
                              Choose a ticket type
                            </Label>
                            {/* <div className="mt-1 relative">
                              <DollarSign className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                              <Input
                                id="ticket_price"
                                name="ticket_price"
                                type="number"
                                min="0"
                                step="0.01"
                                value={eventData.ticket_price}
                                onChange={handleInputChange}
                                className="pl-10"
                                placeholder="0.00"
                                required
                              />
                            </div> */}
                            {/* use custom radio with text */}

                            <div className="mt-2">
                              <RadioGroup
                                defaultValue={
                                  eventData.is_free ? "free" : "paid"
                                }
                                onValueChange={(value) =>
                                  setEventData({
                                    ...eventData,
                                    is_free: value === "free",
                                  })
                                }
                              >
                                <div className="flex items-center gap-[20px]">
                                  <label
                                    htmlFor="ticket_type_free"
                                    className={`flex items-center justify-between border p-2 rounded-[6px] w-[142px] ${
                                      eventData.is_free
                                        ? "border-cecure-700"
                                        : "border-gray-200"
                                    }`}
                                    // onClick={() => setTicket_type("Free")}
                                  >
                                    <div className="flex items-center gap-2">
                                      <img
                                        src={TicketIcon}
                                        className="w-4 h-4"
                                        alt="Free Ticket"
                                      />

                                      <p>Free</p>
                                    </div>
                                    <RadioGroupItem
                                      value="free"
                                      id="ticket_type_free"
                                    >
                                      {/* Free */}
                                    </RadioGroupItem>
                                  </label>

                                  <label
                                    htmlFor="ticket_type_paid"
                                    className={`flex items-center justify-between gap-2 border w-[142px] p-2 rounded-[6px] ${
                                      !eventData.is_free
                                        ? "border-cecure-700"
                                        : "border-gray-200"
                                    }`}
                                    // onClick={() => setTicket_type("Paid")}
                                  >
                                    <div className="flex items-center gap-2">
                                      <img
                                        src={TicketIcon}
                                        className="w-4 h-4"
                                        alt="Paid Ticket"
                                      />

                                      <p>Paid</p>
                                    </div>
                                    <RadioGroupItem
                                      value="paid"
                                      id="ticket_type_paid"
                                    >
                                      Paid
                                    </RadioGroupItem>
                                  </label>
                                </div>
                              </RadioGroup>
                            </div>
                            {/* <div className="mt-2">
                              <RadioGroup
                                defaultValue={eventData.ticket_type}
                                onValueChange={(value) =>
                                  setEventData({
                                    ...eventData,
                                    ticket_type: value,
                                  })
                                }
                              >
                                <div className="flex items-center gap-[20px]">
                                  <div
                                    className={`flex items-center justify-between border p-2 rounded-[6px] w-[142px] ${
                                      eventData.ticket_type === "free" &&
                                      !showPayout
                                        ? "border-cecure-700"
                                        : "border-gray-200"
                                    }`}
                                    onClick={() => setShowPayout(false)}
                                  >
                                    <div className="flex items-center gap-2">
                                      <img
                                        src={TicketIcon}
                                        className="w-4 h-4"
                                        alt="Free Ticket"
                                      />

                                      <p>Free</p>
                                    </div>
                                    <RadioGroupItem
                                      value="free"
                                      id="ticket_type_free"
                                    >
                                      Free
                                    </RadioGroupItem>
                                  </div>

                                  <div
                                    className={`flex items-center justify-between gap-2 border w-[142px] p-2 rounded-[6px] ${
                                      eventData.ticket_type === "paid" &&
                                      showPayout
                                        ? "border-cecure-700"
                                        : "border-gray-200"
                                    }`}
                                    onClick={() => setShowPayout(true)}
                                  >
                                    <div className="flex items-center gap-2">
                                      <img
                                        src={TicketIcon}
                                        className="w-4 h-4"
                                        alt="Paid Ticket"
                                      />

                                      <p>Paid</p>
                                    </div>
                                    <RadioGroupItem
                                      value="paid"
                                      id="ticket_type_paid"
                                    >
                                      Paid
                                    </RadioGroupItem>
                                  </div>
                                </div>
                              </RadioGroup>
                            </div> */}
                          </div>

                          <div>
                            <Label htmlFor="max_attendees">
                              Maximum Attendees
                            </Label>
                            <div className="mt-1 relative flex items-center">
                              <Users className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                              <Input
                                id="max_attendees"
                                name="max_attendees"
                                type="number"
                                max="100"
                                min="0"
                                value={eventData.max_attendees}
                                onChange={handleInputChange}
                                className="pl-10"
                                placeholder="e.g., 100"
                              />
                            </div>

                            {maxAttendeesError && (
                              <p className="text-red-500 text-sm mt-1">
                                {maxAttendeesError}
                              </p>
                            )}
                          </div>
                          {!eventData.is_free && (
                            <div className="flex flex-col">
                              <div>
                                <Label htmlFor="ticket_price">
                                  Ticket Price ($) *
                                </Label>
                                <div className="mt-1 relative">
                                  <DollarSign className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                                  <Input
                                    id="ticket_price"
                                    name="ticket_price"
                                    type="number"
                                    min="1"
                                    step="0.01"
                                    value={eventData.ticket_price}
                                    onChange={handleInputChange}
                                    className="pl-10"
                                    placeholder="0.00"
                                    required
                                  />
                                </div>
                              </div>

                              {/* Payout Account */}
                              <div className="mt-6">
                                <h3 className="font-medium text-lg mb-3">
                                  Payout Account
                                </h3>
                                <div className="rounded-lg border p-4 flex items-center justify-between">
                                  <div className="flex items-center gap-3">
                                    <img
                                      src={BankIcon}
                                      className="w-[32px] h-[32px]"
                                      alt="Bank"
                                    />
                                    <div>
                                      {payoutStatus?.connected ||
                                      payoutResponse?.connected ? (
                                        <p className="text-sm text-gray-500 capitalize">
                                          {payoutStatus?.name ||
                                            payoutResponse?.name}{" "}
                                        </p>
                                      ) : (
                                        <p className="text-sm text-gray-500">
                                          You don’t have a payout account
                                        </p>
                                      )}

                                      {(payoutStatus?.stripeAccountId ||
                                        payoutResponse?.stripeAccountId) && (
                                        <p className="text-xs text-gray-500 capitalize">
                                          {(payoutStatus?.bank_name || "")
                                            .charAt(0)
                                            .toUpperCase() +
                                            (payoutStatus?.bank_name || "")
                                              .slice(1)
                                              .toLowerCase() ||
                                            (payoutResponse?.bank_name || "")
                                              .charAt(0)
                                              .toUpperCase() +
                                              (payoutResponse?.bank_name || "")
                                                .slice(1)
                                                .toLowerCase()}
                                          •
                                          {payoutStatus?.bank_numbers
                                            ?.routing_number ||
                                            payoutResponse?.bank_numbers
                                              ?.routing_number}
                                          •
                                          {(
                                            payoutStatus?.currency ||
                                            payoutResponse?.currency ||
                                            ""
                                          ).toUpperCase()}
                                        </p>

                                        // <p className="text-xs text-gray-500 capitalize">
                                        //   {payoutStatus?.bank_name
                                        //     .charAt(0)
                                        //     .toUpperCase() +
                                        //     payoutStatus?.bank_name
                                        //       .slice(1)
                                        //       .toLowerCase() ||
                                        //     payoutResponse?.bank_name
                                        //       .charAt(0)
                                        //       .toUpperCase() +
                                        //       payoutResponse?.bank_name
                                        //         .slice(1)
                                        //         .toLowerCase()}{" "}
                                        //   •{" "}
                                        //   {payoutStatus?.bank_numbers
                                        //     ?.routing_number ||
                                        //     payoutResponse?.bank_numbers
                                        //       ?.routing_number}{" "}
                                        //   •{" "}
                                        //   {payoutStatus?.currency.toUpperCase() ||
                                        //     payoutResponse?.currency.toUpperCase()}{" "}
                                        // </p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="flex gap-2">
                                    {!isReturningFromPayoutSetup && (
                                      <Button
                                        type="button"
                                        onClick={handleCreatePayoutAccount}
                                        disabled={payoutLoading}
                                      >
                                        {payoutLoading
                                          ? "Processing..."
                                          : "Add Account"}
                                      </Button>
                                    )}
                                    {/* {
                                      !payoutStatus?.stripeAccountId ||
                                        (!payoutResponse?.stripeAccountId && (
                                          <Button
                                            type="button"
                                            onClick={handleCreatePayoutAccount}
                                            disabled={payoutLoading}
                                          >
                                            {payoutLoading
                                              ? "Processing..."
                                              : "Add Account"}
                                          </Button>
                                        ))

                                      : (
                                        <Button
                                          type="button"
                                          variant="outline"
                                          onClick={handleUpdatePayoutAccount}
                                          disabled={payoutLoading}
                                        >
                                          {payoutLoading
                                            ? "Opening..."
                                            : "Manage Account"}
                                        </Button>
                                      )
                                    } */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Ticket Type Manager */}
                        <div className="mt-8">
                          <TicketTypeManager
                            // eventData={eventData}
                            ticketTypes={ticketTypes}
                            onTicketTypesChange={setTicketTypes}
                            accountType={loggedInUser?.account_type}
                            // showUpgradeModal={showUpgradeModal}
                            onUpgradeClick={handleShowUpgradeModal}
                          />
                        </div>
                      </TabsContent>

                      <TabsContent value="form" className="space-y-6 mt-4">
                        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
                          <h4 className="font-medium mb-2">
                            Registration Form Builder
                          </h4>
                          <p className="text-sm text-gray-600 mb-4">
                            You'll be able to customize your registration form
                            after creating your event. By default, we collect:
                          </p>
                          <ul className="space-y-2 text-sm text-gray-600">
                            <li className="flex items-center">
                              <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                              Name
                            </li>
                            <li className="flex items-center">
                              <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                              Email Address
                            </li>
                            <li className="flex items-center">
                              <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                              Phone Number (optional)
                            </li>
                          </ul>

                          {loggedInUser?.account_type?.account_type ===
                            "standard" && (
                            <div className="mt-6">
                              <UpgradePrompt
                                compact
                                title="Custom Registration Fields"
                                description="Create custom registration fields to collect the exact information you need from your attendees."
                                featuresList={[
                                  "Unlimited custom fields",
                                  "Conditional fields",
                                  "File uploads",
                                  "Custom validation",
                                ]}
                                onUpgradeClick={handleShowUpgradeModal}
                              />
                            </div>
                          )}
                        </div>
                      </TabsContent>
                    </Tabs>
                  </div>

                  <div className="mt-8 flex justify-between">
                    <Button type="button" variant="outline" onClick={prevStep}>
                      Back
                    </Button>
                    <Button type="button" onClick={nextStep}>
                      Next: Review
                    </Button>
                  </div>
                </CardContent>
              </Card>
            )}

            {/* ==Step 3: Review== */}
            {currentStep === 3 && (
              <Card>
                <CardContent className="pt-6">
                  <h2 className="text-xl font-semibold mb-4">
                    Review Your Event
                  </h2>

                  <div className="space-y-6">
                    <div className="grid grid-cols-1  gap-8">
                      <div>
                        <h3 className="font-medium text-lg mb-4">
                          Event Details
                        </h3>

                        <div className="grid gap-3 md:grid-cols-3">
                          <div>
                            <p className="text-sm text-gray-500">Title</p>
                            <p className="font-medium break-words">
                              {eventData.title || "Not specified"}
                            </p>
                          </div>

                          <div>
                            <p className="text-sm text-gray-500">Category</p>
                            <p className="font-medium">
                              {eventData.category || "Not specified"}
                            </p>
                          </div>

                          <div>
                            <p className="text-sm text-gray-500">Date & Time</p>
                            <p className="font-medium">
                              {eventData.date ? (
                                <>
                                  {new Date(eventData.date).toLocaleDateString(
                                    "en-US",
                                    {
                                      weekday: "long",
                                      year: "numeric",
                                      month: "long",
                                      day: "numeric",
                                    }
                                  )}
                                  {eventData.startTime && eventData.endTime ? (
                                    <>
                                      , {eventData.startTime} -{" "}
                                      {eventData.endTime}
                                    </>
                                  ) : null}
                                </>
                              ) : (
                                "Not specified"
                              )}
                            </p>
                          </div>

                          <div>
                            <p className="text-sm text-gray-500">
                              {eventData.isVirtual === "Yes"
                                ? "Virtual Event Link"
                                : "Location"}
                            </p>
                            <p className="font-medium break-words">
                              {eventData.isVirtual === "Yes"
                                ? eventData.meetingLink
                                : eventData.location}
                              {/* {eventData.location || "Not specified"} */}
                            </p>
                          </div>

                          <div>
                            <p className="text-sm text-gray-500">Description</p>
                            <p className="font-medium">
                              {eventData.description || "Not specified"}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div>
                        <h3 className="font-medium text-lg mb-4">
                          Registration Details
                        </h3>

                        <div className="grid  md:grid-cols-3 gap-3">
                          {!eventData.is_free && (
                            <div>
                              <p className="text-sm text-gray-500">
                                Ticket Price
                              </p>
                              <p className="font-medium">
                                {`$${eventData.ticket_price}`}
                              </p>
                            </div>
                          )}

                          <div>
                            <p className="text-sm text-gray-500">Ticket Type</p>
                            <p className="font-medium capitalize">
                              {eventData.is_free ? "Free" : "Paid"}
                            </p>
                          </div>
                          <div>
                            <p className="text-sm text-gray-500">
                              Maximum Attendees
                            </p>
                            <p className="font-medium">
                              {eventData.max_attendees || "Unlimited"}
                            </p>
                          </div>

                          {/* <div className="flex items-center gap-2">
                            <img
                              src={BankIcon}
                              className="w-[44px] h-[44px]"
                              alt="Payout"
                            />
                            <div>
                              <p className="font-medium">
                                {payoutStatus?.payouts_enabled
                                  ? "Payouts enabled"
                                  : "Payout account not connected"}
                              </p>
                              {payoutStatus?.account_id && (
                                <p className="text-sm text-gray-600">
                                  {payoutStatus?.country || ""} •{" "}
                                  {payoutStatus?.business_type || ""}
                                </p>
                              )}
                            </div>
                          </div> */}
                          {ticketTypes && ticketTypes.length > 0 && (
                            <div>
                              <p className="text-sm text-gray-500">
                                Additional Ticket Types
                              </p>
                              <ul className="list-disc pl-5">
                                {ticketTypes.map((ticket) => (
                                  <li key={ticket.id} className="text-sm">
                                    {ticket.name}: ${ticket.price.toFixed(2)}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>

                        {/* <div className="mt-8">
                          <h3 className="font-medium text-lg mb-4">
                            Payment Processing
                          </h3>
                          <p className="text-sm text-gray-600">
                            You'll be able to connect your payment processor
                            (Stripe or PayPal) after creating your event.
                          </p>
                        </div> */}
                      </div>
                    </div>

                    {/* <div className="border-t pt-6">
                      <h3 className="font-medium text-lg mb-2">
                        Event Description
                      </h3>
                      <p className="text-gray-800 break-words">
                        {eventData.description || "No description provided."}
                      </p>
                    </div> */}
                  </div>

                  <div className="mt-8 flex justify-between">
                    <Button type="button" variant="outline" onClick={prevStep}>
                      Back
                    </Button>
                    <Button
                      type="submit"
                      disabled={loading}
                      className="flex items-center gap-2"
                    >
                      {isEditMode ? "Update Event" : "Create Event"}
                      {loading && <span>Loading...</span>}
                    </Button>
                  </div>
                </CardContent>
              </Card>
            )}
          </form>
        </div>
      </main>
      <Footer />
      <UpgradeModal
        isOpen={showUpgradeModal}
        onClose={() => {
          setShowUpgradeModal(false);
          setIsPro(false);
        }}
        isPro={isPro}
        handleUpgrade={handleUpgrade}
        featureName={upgradeFeatureName}
      />
    </div>
  );
};

export default CreateEvent;
